import { DUE_SOON_PERCENT } from '../../constants';
import type { Drone, ModelServiceIntervalMap, PartType } from '../../types';
import { getDroneIntervals } from '../getDroneIntervals';
import { getWearPercent } from '../getWearPercent';

export const isDueSoon = ({
    drone,
    serviceIntervals
}: {
    drone: Drone;
    serviceIntervals: ModelServiceIntervalMap;
}): boolean => {
    const droneIntervals = getDroneIntervals({ drone, serviceIntervals });

    return (Object.keys(drone.usage) as PartType[]).some(part => {
        const wearStatus = getWearPercent({
            interval: droneIntervals[part],
            usage: drone.usage[part] ?? 0
        });

        return wearStatus.configured && wearStatus.percentage >= DUE_SOON_PERCENT;
    });
};
